<template>
    <div v-if="false">
        <!-- Componente invisible que verifica versiones -->
    </div>
</template>

<script>
export default {
    name: 'VersionChecker',

    data() {
        return {
            currentVersion: process.env.VUE_APP_VERSION || 'dev',
            checkInterval: null
        };
    },

    mounted() {
        // Guardar la versión actual en sessionStorage
        const storedVersion = sessionStorage.getItem('app_version');

        if (storedVersion && storedVersion !== this.currentVersion) {
            console.log('🔄 Nueva versión detectada');
            console.log(`📦 Versión anterior: ${storedVersion}`);
            console.log(`✨ Versión actual: ${this.currentVersion}`);

            // CAMBIO: Solo guardar la nueva versión, NO limpiar todo
            sessionStorage.setItem('app_version', this.currentVersion);

            // Mostrar notificación y recargar SIN TIMEOUT
            this.$store.dispatch('notificaciones/showSnack', {
                message: 'Nueva versión disponible. Recargando...',
                type: 'info'
            }, { root: true });

            // Recargar inmediatamente (el navegador descargará los nuevos archivos por el hash)
            setTimeout(() => {
                window.location.reload(true);
            }, 1500);
        } else {
            // Primera carga o misma versión
            sessionStorage.setItem('app_version', this.currentVersion);
        }

        // Verificar cada 10 minutos si hay nueva versión
        this.checkInterval = setInterval(() => {
            this.checkForUpdates();
        }, 10 * 60 * 1000);
    },

    beforeDestroy() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
    },

    methods: {
        async checkForUpdates() {
            try {
                // Hacer un fetch al index.html para ver si cambió
                const response = await fetch('/afiliados/index.html?' + Date.now(), {
                    cache: 'no-cache'
                });

                const html = await response.text();

                // Buscar si hay archivos JS/CSS con nuevos hashes
                const jsRegex = /src="[^"]*\.js\?v=([^"]+)"/g;
                const matches = [...html.matchAll(jsRegex)];

                if (matches.length > 0) {
                    const currentStoredVersion = sessionStorage.getItem('app_version');

                    // Verificar si cambió la versión en el HTML
                    if (currentStoredVersion !== this.currentVersion) {
                        console.log('🔄 Actualización detectada en checkForUpdates');

                        this.$store.dispatch('notificaciones/showSnack', {
                            message: 'Hay una actualización disponible. Recargando...',
                            type: 'info'
                        }, { root: true });

                        // Actualizar versión y recargar
                        sessionStorage.setItem('app_version', this.currentVersion);

                        setTimeout(() => {
                            window.location.reload(true);
                        }, 1500);
                    }
                }
            } catch (error) {
                console.error('Error verificando actualizaciones:', error);
            }
        }
    }
};
</script>
